import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StylingService, Theme } from 'src/app/services/style-service/styling.service';
import { IframeRecivedService } from 'src/app/shared/navbar/navbar-vesax/iframe-recieved.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tablet-modal',
  templateUrl: './tablet-modal.component.html',
  styleUrls: ['./tablet-modal.component.scss'],
  standalone:false
})
export class TabletModalComponent implements OnInit {
  @Input() isOpen = false;
  iframeSrc: SafeResourceUrl='';
  constructor(
    public styleService: StylingService,
    public iframeService: IframeRecivedService,
    private sanitizer: DomSanitizer
  ) { 
    this.iframeSrc = `${environment.designerIframe}#/iframepreviewappbright`;
  }

  ngOnInit(): void {
    this.iframeService.styleTypeSub.subscribe((styleType) => {
      this.setIframe(styleType ?? 2);
    });
  }
  setIframe(styleType: number) {
    const url =
      styleType === 2 || styleType === 0 || styleType === 5
        ? `${environment.designerIframe}#/iframepreviewappbright`
        : `${environment.designerIframe}#/iframepreviewappdark`;

    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public get theme(): typeof Theme {
    return Theme;
  }

}
